import {
  fetchAll,
  fetchFiltered,
  addShippingDestinyTransportation,
  show,
  edit,
} from "@/api/shippingdestinytransportation";

const state = {
  all: [],
  isLoading: false,
  shippingDestinyTransportation: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const shippingDestinyTransportation = await show(id);

      commit("setShippingDestinyTransportation", shippingDestinyTransportation);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const shippingDestinyTransportations = await fetchAll();

      commit("setAll", shippingDestinyTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const shippingDestinyTransportations = await fetchFiltered(queriesParams);

      commit("setAll", shippingDestinyTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      commit("setLoading", true);

      await addShippingDestinyTransportation(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      commit("setLoading", true);

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.shippingDestinyTransportation = null;
  },

  setAll(state, shippingDestinyTransportations) {
    state.all = shippingDestinyTransportations;
  },

  setShippingDestinyTransportation(state, shippingDestinyTransportation) {
    state.shippingDestinyTransportation = shippingDestinyTransportation;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
